import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController ,LoadingController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
 

@IonicPage()
@Component({
  selector: 'page-listoddocuments',
  templateUrl: 'listoddocuments.html',
})
export class ListoddocumentsPage {
  arrReason:any=[];
  errorDisplay:any={};
  listCategotyComplains:any=[];
  listSubCategotyComplains:any=[];
  category:any="";
  subcomplain:any="";
  ccs_remarks:any="";
  reason:any=""
  constructor(
    private loadingCtrl:LoadingController,
    public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }
  presentActionSheet(msg) {
      const actionSheet = this.actionSheetCtrl.create({
        title: msg,
        cssClass: 'commanSheet',
        buttons: [
          {
            text: "OK",
            role: 'Ok',
            handler: () => {
               actionSheet.dismiss();
            }
          }
        ]
      });
      actionSheet.present();
    }
   presentActionSheetGstConfirmation(msg) {
      const actionSheet = this.actionSheetCtrl.create({
        title: msg,
        cssClass: 'commanSheet',
        buttons: [
          {
            text: "Yes",
            role: 'yes',
            handler: () => {
               var ccs_casecategory="CC01";;
                var ccs_casetype="CT107";
                var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
                var ccs_originatingsource="S01"
                var ccs_casesubtype = "WHQLOD";//"STD202";
                var ccs_remarks = this.ccs_remarks;
                let loading = this.loadingCtrl.create({
                  content: 'Please wait...'
                });
                loading.present();

                this.cp.postRetforclosure(loading,
                                        ccs_casecategory,
                                        ccs_remarks,
                                        JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,
                                        ccs_casetype,
                                        ibhfl_loanaccountnumber1,
                                        ccs_originatingsource,
                                        ccs_casesubtype,this.reason,"ListOfDocument").then((res:any)=>{
                                        loading.dismiss();
                                        var res=JSON.parse(res)
                                        if(res.Payload)
                                        {
                                          this.presentActionSheet("Your Request. "+res.Payload.caseid+" has been created.Document will br shared on register E-mail ID with in 21 days.")
                                        }
                                       })
                                        actionSheet.dismiss();
               
               }
               
               
          },
          {
              text: "No",
              role: 'no',
              handler: () => {
                this.presentActionSheet("Your request not processed.For further assistance please visit our branch or contact our customer care at 1800-572-7777.");
                 actionSheet.dismiss();
              }
          }
        ]
      });
      actionSheet.present();
    } 
  ionViewDidLoad() {
    ////console.log('ionViewDidLoad ForseclousrestatementsPage');
    this.getForeclousreCategoryDetails();
  }

  getForeclousreCategoryDetails(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    this.cp.getForClousreCategory(loading).then((res:any)=>{
      var res=JSON.parse(res)
      loading.dismiss();
      this.arrReason = res.Payload.ibhfl_reasonsforretentiondocumentrequirements.filter((resF:any)=>resF.lod==true);
      // ////console.log(res.Payload.ibhfl_reasonsforretentiondocumentrequirements);
    })
  }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    if(this.reason==""){
    this.errorDisplay.reason="Reason is required";
    return false;
   }
    if(this.errorDisplay.valid){
     return false;
   }else{
    this.presentActionSheetGstConfirmation("Please provide your consent to pay charges.Applicable charges are INR 1000 plus GST.");
   }
 }

}



// WEBPACK FOOTER //
// ./src/pages/listoddocuments/listoddocuments.ts